import React, { useContext, useEffect, useRef } from 'react'
import { useHistory } from 'react-router-dom'
import { useDispatch, shallowEqual, useSelector } from 'react-redux'
import { createSelector } from 'reselect'

import { Grid } from '@material-ui/core'

import EcommerceFound from './EcommerceFound'
import { trackApi } from './ItemEcommerce'

import actions from '~/actions'
import { selectPosition } from '~/selectors'
import { EcommerceContext } from './DrawerEcommerce'

const selector = createSelector(
  (state) => state.app,
  (state) => state.dialog,
  (...args) => args,
)

export default function RenderEcommerce({
  handleClose,
  dataEcommerce,
  loadingEcommerce,
  configEcommerce,
  openEcommerce,
  setOpenEcommerce,
}) {
  const { dataOffers, hasStoresManuals } = useContext(EcommerceContext)

  const divEcommerceRef = useRef(null)
  const [app, dialog] = useSelector(selector, shallowEqual)
  const [position] = useSelector(selectPosition, shallowEqual)

  const dispatch = useDispatch()
  const history = useHistory()

  const { stores } = app

  const handleReturn = () => {
    dispatch(actions.dialog.error(false))
    dispatch(actions.dialog.reset())
    setOpenEcommerce(null)

    if (!stores || !stores.length) history.push('/')
  }

  const handleLogger = (data) => {
    const product = openEcommerce
    const config = configEcommerce

    trackApi(
      { event: 'seeOnlineStore', url: data.url, subdomain: config.brandName, price: data.price },
      product,
      data,
      config,
      position,
    )
  }

  useEffect(() => {
    if (divEcommerceRef.current) {
      const { dialogs } = dialog

      if (dialogs.length) {
        const modalRootFindProduct = document.getElementById('dialog-find-product')

        modalRootFindProduct.style.display = 'none'
      }
    }
  }, [dialog, divEcommerceRef])

  return (
    <Grid ref={divEcommerceRef}>
      <EcommerceFound
        isManually={!dataOffers.length && hasStoresManuals}
        dataEcommerce={dataEcommerce}
        openEcommerce={openEcommerce}
        loadingEcommerce={loadingEcommerce}
        configEcommerce={configEcommerce}
        handleLogger={handleLogger}
        onClose={handleClose || handleReturn}
      />
    </Grid>
  )
}
